
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { RequestedValue$1_$reflection, RoleId_$reflection } from "../../../Shared/Shared.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../../../Shared/Roles.js";
import { union_type, class_type, record_type, bool_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";

export class State extends Record {
    constructor(RoleId, Roles, Assignments, Storages, IsDeleteDialogOpen) {
        super();
        this.RoleId = RoleId;
        this.Roles = Roles;
        this.Assignments = Assignments;
        this.Storages = Storages;
        this.IsDeleteDialogOpen = IsDeleteDialogOpen;
    }
}

export function State_$reflection() {
    return record_type("Settings.Roles.Detail.Types.State", [], State, () => [["RoleId", RoleId_$reflection()], ["Roles", RequestedValue$1_$reflection(list_type(RoleDefinition_$reflection()))], ["Assignments", RequestedValue$1_$reflection(list_type(UserRoleAssignmentDto_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["IsDeleteDialogOpen", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RolesFetched", "AssignmentsFetched", "StoragesFetched", "OpenDeleteDialog", "CloseDeleteDialog", "RoleDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Roles.Detail.Types.Msg", [], Msg, () => [[["Item", list_type(RoleDefinition_$reflection())]], [["Item", list_type(UserRoleAssignmentDto_$reflection())]], [["Item", list_type(Storage_$reflection())]], [], [], [], [["Item", class_type("System.Exception")]]]);
}

